import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgFileCopyIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.6 6.4a3.2 3.2 0 0 1 3.2-3.2h28.8v3.2H12.8v28.8H9.6zm9.6 9.6a3.2 3.2 0 0 1 3.2-3.2H40a1.6 1.6 0 0 1 1.131.469l12.8 12.8c.3.3.469.707.469 1.13v30.4a3.2 3.2 0 0 1-3.2 3.2H22.4a3.2 3.2 0 0 1-3.2-3.2zm19.2 0h-16v41.6h28.8V28.8h-9.6a3.2 3.2 0 0 1-3.2-3.2zm3.2 2.263V25.6h7.337zM44.8 38.4h-16v-3.2h16zm0 9.6h-16v-3.2h16z"
    />
  </svg>
)
export default SvgFileCopyIcon
